// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fFZpn","helpContainer":"styles_helpContainer__vJsdN","lightBulbIcon":"styles_lightBulbIcon__AeWRJ"};